import { render } from "./StockInfoCard.vue?vue&type=template&id=ae8e04ec&scoped=true&ts=true"
import script from "./StockInfoCard.vue?vue&type=script&lang=ts"
export * from "./StockInfoCard.vue?vue&type=script&lang=ts"

import "./StockInfoCard.vue?vue&type=style&index=0&id=ae8e04ec&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8e04ec"]])

export default __exports__